<template>
  <div>
    <span v-for="file in files.sort((a, b) => !['png','jpg','gif'].includes(a.name.toLowerCase().split('.')[1]))" :key="file.name">
      <span v-if="['png','jpg','gif'].includes(file.name.toLowerCase().split('.')[1])">
        <b-img :src="file.blob" @click="viewImg(file)" thumbnail fluid
        style="max-width: 16rem; min-height: 8rem; max-height: 8rem; cursor: pointer" class="mr-1 mb-1"/>
      </span>
      <b-button v-else class="mb-2 mr-2" variant="outline-dark" size="sm" @click="downloadFile(file)">
        <font-awesome-icon class="mr-1" :icon="['far', 'file']"/>{{ file.name }}
      </b-button>
    </span>
    <b-modal id="img_modal" size="xl" content-class="shadow text-center" :title="this.selectedImg" centered ref="img_modal">
      <b-img fluid class="ml-0 mr-0" :src="modalImg"></b-img>
      <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click.prevent="downloadFile({ name: selectedImg, blob: modalImg })">
        <font-awesome-icon :icon="['fas', 'download']"/>
        Descarregar arxiu
      </b-btn>
    </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    files: {
      required: true,
      type: Array
    },
    ticket_id: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      selectedImg: '',
      modalImg: ''
    }
  },
  methods: {
    viewImg (file) {
      this.selectedImg = file.name
      this.modalImg = file.blob
      this.$refs.img_modal.show()
    },
    downloadFile (file) {
      const link = document.createElement('a')
      link.href = file.blob
      link.setAttribute('download', file.name)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>
